import { useEffect, useState } from 'react'

const SubmissionSuccess = () => {
  
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="rounded-2xl border border-slate-200 bg-white px-8 py-10 shadow-sm">
        {/* Checkmark */}
        <div className="flex justify-center mb-6">
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            aria-hidden="true"
          >
            <circle
              cx="36"
              cy="36"
              r="33"
              stroke="#0F766E"
              strokeWidth="2.5"
              className={[
                "origin-center transition-[stroke-dashoffset] duration-700 ease-out",
              ].join(" ")}
              style={{
                strokeDasharray: 208,
                strokeDashoffset: mounted ? 0 : 208,
              }}
            />
            <path
              d="M22 37.5L31.5 47L50 26"
              stroke="#0F766E"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{
                strokeDasharray: 40,
                strokeDashoffset: mounted ? 0 : 40,
                transition: "stroke-dashoffset 450ms ease-out",
                transitionDelay: "550ms",
              }}
            />
          </svg>
        </div>

        {/* Copy */}
        <div
          className="text-center transition-opacity duration-500"
          style={{ opacity: mounted ? 1 : 0, transitionDelay: "300ms" }}
        >
          <h2 className="text-lg font-semibold text-slate-900">
            Submitted successfully
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-slate-500">
            We've received your submission and it's being processed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubmissionSuccess;